import React from 'react';
import classNames from 'classnames';

interface Props {
  className?: string;
}

const FocusOverlay = (props: Props) => <div className={classNames('focus-overlay', props.className)}>&nbsp;</div>;

export default FocusOverlay;
